// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__TL9Uz","container":"Footer_container__c0Q1z","section":"Footer_section__ARcjj","bottom":"Footer_bottom__syzdZ"};